import React from "react";
import { useOutletContext, useParams } from "react-router-dom";
import ProjectChatInterface from "../components/project/ProjectChatInterface";

const ProjectSession = (props) => {
    const { isMobile, sidebarOpen, setProjectChats, projectChats, fetchRecentChats, chatModels, setModelSelectorConfig } =
        useOutletContext();
    const { name, projectId, sessionId } = useParams();

    return (
        <ProjectChatInterface
            isMobile={isMobile}
            sidebarOpen={sidebarOpen}
            setChats={setProjectChats}
            chats={projectChats}
            fetchRecentChats={fetchRecentChats}
            chatModels={chatModels}
            setModelSelectorConfig={setModelSelectorConfig}
            projectName={decodeURIComponent(name)}
            projectId={projectId}
            sessionId={sessionId}
        />
    );
};

export default ProjectSession;
